import { ActionTypes } from "../constants/action-types"

const initialState = {
    programImageById: null
}

const FetchProgramImageById = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.FETCH_PROGRAM_IMAGE_BY_ID:
            return { ...state, programImageById: payload };
        default: return state;
    }
}

export default FetchProgramImageById;
